// original directive is based on 
// https://github.com/izupet/angular2-counto
// adapted it to suit our architecture and needs

import {Directive, Output, EventEmitter} from '@angular/core';
import {EventBus} from "../event/EventBus";
import {PointCounterEvent} from "../event/StepEvents";
import {ComponentBase} from "../base/ComponentBase";
import {filter} from "rxjs/operators";

@Directive({
    selector: 'counto',
    inputs: ['duration', 'countFrom', 'countTo', 'step']
})

export class Counto extends ComponentBase {

    @Output() countoChange = new EventEmitter();
    private _timer;
    private _duration: number;
    private _countTo: number;
    private _countFrom: number;
    private _step: number;

    constructor(private eventBus: EventBus) {
        super("Counto");

        let sub = this.eventBus.pipe(filter((e: PointCounterEvent) => e.type === PointCounterEvent.TYPE))
            .subscribe((e: PointCounterEvent) => {
                if (this._countTo !== Number(e.getValue())) {
                    this._countTo = e.getValue();
                    this.run();
                }
            });

        this.subscriptions.push(sub);
    }

    set duration(duration) {
        this._duration = parseFloat(duration);
        this.run();
    }

    set countTo(countTo) {
        this._countTo = parseFloat(countTo);
        this.run();
    }

    set countFrom(countFrom) {
        this._countFrom = parseFloat(countFrom);
        this.run();
    }

    set step(step) {
        this._step = parseFloat(step);
        this.run();
    }

    run() {
        clearInterval(this._timer);
        if (!isNaN(this._duration) && !isNaN(this._step) && !isNaN(this._countFrom) && !isNaN(this._countTo)) {
            var intermediate  = this._countFrom;
            var increment     = Math.abs(this._countTo - this._countFrom) / ((this._duration * 1000) / this._step);

            this.countoChange.emit(intermediate);

            this._timer = setInterval(() => {
                if (this._countTo < this._countFrom) {
                    if (intermediate <= this._countTo) {
                        clearInterval(this._timer);
                        this.countoChange.emit(this._countTo);
                    } else {
                        this.countoChange.emit(intermediate);
                        intermediate -= Math.ceil(increment);
                    }
                } else {
                    if (intermediate >= this._countTo) {
                        clearInterval(this._timer);
                        this.countoChange.emit(this._countTo);
                    } else {
                        this.countoChange.emit(intermediate);
                        intermediate += Math.ceil(increment);
                    }
                }
            }, this._step);
        }
    }
}
